<template>
    <jet-form-section @submitted="updateProfileInformation">
        <template #title>
            Profile Information
        </template>

        <template #description>
            Update your account's profile information.
        </template>

        <template #form>
            <!-- Profile Photo -->
            <div
                class="col-span-6 sm:col-span-4"
                v-if="$page.props.jetstream.managesProfilePhotos"
            >
                <!-- Profile Photo File Input -->
                <input
                    type="file"
                    class="hidden"
                    ref="photo"
                    @change="updatePhotoPreview"
                />

                <jet-label for="photo" value="Photo" />

                <!-- Current Profile Photo -->
                <div class="mt-2" v-show="!photoPreview">
                    <img
                        :src="$page.props.auth.user.profile_photo_url"
                        alt="Current Profile Photo"
                        class="rounded-full h-20 w-20 object-cover"
                    />
                </div>

                <!-- New Profile Photo Preview -->
                <div class="mt-2" v-show="photoPreview">
                    <span
                        class="block rounded-full w-20 h-20"
                        :style="
                            'background-size: cover; background-repeat: no-repeat; background-position: center center; background-image: url(\'' +
                                photoPreview +
                                '\');'
                        "
                    >
                    </span>
                </div>

                <jet-secondary-button
                    class="mt-2"
                    type="button"
                    @click.native.prevent="selectNewPhoto"
                >
                    Select A New Photo
                </jet-secondary-button>

                <jet-input-error v-if="form.errors.updateProfileInformation" :message="form.errors.updateProfileInformation.photo" class="mt-2" />
            </div>

            <!-- Name -->
            <div class="col-span-6 sm:col-span-4">
                <jet-label for="name" value="Name" />
                <jet-input
                    id="name"
                    type="text"
                    class="mt-1 block w-full"
                    v-model="form.name"
                    autocomplete="name"
                />
                <jet-input-error v-if="form.errors.updateProfileInformation" :message="form.errors.updateProfileInformation.name" class="mt-2" />
            </div>

            <!-- Email -->
            <div class="col-span-6 sm:col-span-4">
                <jet-label for="email" value="Email" />
                <jet-input
                    id="email"
                    type="email"
                    class="mt-1 block w-full"
                    v-model="form.email"
                />
                <jet-input-error v-if="form.errors.updateProfileInformation" :message="form.errors.updateProfileInformation.email" class="mt-2" />
            </div>

            <!-- Email -->
            <div class="col-span-6 sm:col-span-4">
                <div class="text-gray-700">
                    <label class="text-gray-700 font-normal text-14px mb-1">
                        Timezone
                    </label>

                    <select
                        id="timezone"
                        class="mt-1 block w-full rounded text-black"
                        v-model="form.timezone"
                    >
                        <option v-for="timezone in timezoneOptions" :key="timezone" :value="timezone.value">
                            {{ timezone.label }}
                        </option>
                    </select>

                    <jet-input-error v-if="form.errors.updateProfileInformation" :message="form.errors.updateProfileInformation.timezone" class="mt-2" />   
                </div>
            </div>

            <!-- Org Name - Only visible to admins -->
            <div class="col-span-6 sm:col-span-4" v-if="$page.props.is_admin">
                <jet-label for="organization_title" value="Organization Name" />
                <jet-input
                    id="organization_title"
                    type="text"
                    class="mt-1 block w-full"
                    v-model="form.organizationName"
                    autocomplete="name"
                />
                <jet-input-error v-if="form.errors.updateProfileInformation" :message="form.errors.updateProfileInformation.organizationName" class="mt-2" />
            </div>
        </template>

        <template #actions>
            <jet-action-message :on="form.recentlySuccessful" class="mr-3">
                Saved.
            </jet-action-message>

            <jet-button
                :class="{ 'opacity-25': form.processing }"
                :disabled="form.processing"
            >
                Save
            </jet-button>
        </template>
    </jet-form-section>
</template>

<script>
import JetButton from "./../../Jetstream/Button";
import JetFormSection from "./../../Jetstream/FormSection";
import JetInput from "./../../Jetstream/Input";
import JetInputError from "./../../Jetstream/InputError";
import JetLabel from "./../../Jetstream/Label";
import JetActionMessage from "./../../Jetstream/ActionMessage";
import JetSecondaryButton from "./../../Jetstream/SecondaryButton";
import timezones from "../../helpers/timezones";

export default {
    components: {
        JetActionMessage,
        JetButton,
        JetFormSection,
        JetInput,
        JetInputError,
        JetLabel,
        JetSecondaryButton
    },

    props: ["name", "email"],

    data() {
        return {
            form: this.$inertia.form(
                {
                    _method: "PUT",
                    name: this.name,
                    email: this.email,
                    photo: null,
                    timezone: this.$page.props.auth.user.timezone,
                    organizationName: this.$page.props.auth.user.organization.title,
                },
                {
                    bag: "updateProfileInformation",
                    resetOnSuccess: false
                }
            ),

            photoPreview: null,
            timezones,
        };
    },

    methods: {
        updateProfileInformation() {
            if (this.$refs.photo) {
                this.form.photo = this.$refs.photo.files[0];
            }

            this.form.post("/user/profile-information", {
                preserveScroll: true
            });
        },

        selectNewPhoto() {
            this.$refs.photo.click();
        },

        updatePhotoPreview() {
            const reader = new FileReader();

            reader.onload = e => {
                this.photoPreview = e.target.result;
            };

            reader.readAsDataURL(this.$refs.photo.files[0]);
        }
    },
    computed: {
        timezoneOptions() {
            const result = [];
    
            this.timezones.forEach(region => {
                if (region.children && region.children.length) {
                    // For each region (US, etc.)
                    region.children.forEach(timezone => {
                        // Add each timezone with its full context
                        result.push({
                            regionLabel: region.label,
    /*                        label: timezone.label, */
                            value: timezone.value,
                            label: `${region.label} - ${timezone.label}`
                        });
                    });
                }
            });
    
            return result;
        }//ends timezoneOptions
    }, //ends computed
};
</script>
